'use strict';

const debounce = require('./modules/helpers/debounce');
const equalHeight = require('./modules/helpers/equalHeight');
const isSmallView = require('./modules/helpers/isSmallView');
const prepareDeferedImages = require('./modules/helpers/prepareDeferedImages');
const scrollHelper = require('./modules/helpers/scroll');

// Masonry
const Masonry = require('masonry-layout');
const ScrollReveal = require('scrollreveal');
const generateUniqueGuid = require('./modules/util/generateUniqueGuid');
const updateQueryStringParameter = require('./modules/util/updateQueryStringParameter');
const getQueryParameter = require('./modules/util/getQueryParameter');
const damHelper = require('./dam/dam-helper');

const tilesSelector = '.js-grid-wrap';
const masonryTileSelector = '.js-grid-item';
const scrollRevealTileSelector = '.js-reveal-tile';
const scrollRevealDurations = [500, 1500, 2500, 3500];
const scrollRevealDistance = ['10px', '20px', '30px', '40px'];
const msnryContainers = new Map();
let initCount = 0;
const isSearchPage = window.pageContext.ns == 'search';
const scrollAnimation = require('./scrollAnimation');
const productGrid = require('./product-grid');
const bundleVariationSwatches = require('./bundle-variation-swatches');
const pushDataLayerEvent = require('../../src/js/modules/helpers/analyticsHelper');

const tileSelectors = ['.js-grid-wrap:not(.js-grid-slider) .js-grid-item:not(.js-block-tile)','.drag-list-body .js-drag-list-item'];

function getGutter(grid){
    if (grid.hasClass('js-question-grid')) {
        return 20;
    } else if (grid.hasClass('js-grid-account')) {
        return 20;
    } else if (grid.hasClass('js-search-grid') && isSmallView()) {
        return 8;
    } else if (isSmallView()) {
        return 10;
    } else if (grid.hasClass('js-search-grid') && isTabletPortraitView()) {
        return 24;
    } else if (grid.hasClass('js-search-grid') && isTabletLandscapeView()) {
        return 18;
    } else if (grid.parents('.js-product-grid-block').length && isTabletPortraitView()) {
        return 30;
    } else if (grid.parents('.js-product-grid-block').length && isTabletLandscapeView()) {
        return 40;
    } else {
        return 60;
    }
}

function isTabletPortraitView() {
    const vpWidth = $(window).width();
    return vpWidth >= 768 && vpWidth <= 825;
}

function isTabletLandscapeView() {
    const vpWidth = $(window).width();
    return vpWidth >= 826 && vpWidth <= 1024;
}

function initMasonry(el) {
    const targetEl = $(el)[0];
    const msnryObj = new Masonry(targetEl, {
        columnWidth: masonryTileSelector,
        gutter: getGutter($(targetEl)),
        itemSelector: masonryTileSelector,
        isFit: true,
        percentPosition: true,
        stagger: '0.1s',
        transitionDuration: 0,
        stamp: '.js-fixed-item'
    });

    $(targetEl).addClass('grid-initialized');

    const msnryId = generateUniqueGuid();
    $(el).data('msnry-id', msnryId);
    msnryContainers.set(msnryId, msnryObj);

    return msnryObj;
}

function initScrollReveal(scrollSelector, gridElement) {
    if (!window.sr){
        window.sr = ScrollReveal();
    } else {
        window.sr.destroy();
    }

    gridElement.find(scrollSelector).each(function(i, el) {
        sr.reveal(el, { /* eslint-disable-line */
            distance: randomArrayKeyValue(scrollRevealDistance),
            duration: randomArrayKeyValue(scrollRevealDurations),
            easing: 'cubic-bezier(0.05, 0.65, 0.3, 1)',
            opacity: 0.2,
            scale: 1,
            viewFactor: 0.2
        });
    });
}

function randomArrayKeyValue(a) {
    return a[Math.floor(Math.random() * a.length)];
}

/**
* @description Initialize Recommendation(Einstein) grid observer and init grids when loaded.
*/
function initRecommendationGridObserver() {
    // set a MutationObserver for each recommendation slot
    $('[id^=cq_recomm]').each(function (index, el){
        const target = $(el)[0];
        // set mutation observer
        const observer = new MutationObserver(function() {

            // Prepare defered images if present
            damHelper.updateImages(target);
            prepareDeferedImages(target);

            // init every grid in that slot
            $(target).imagesLoaded(function () {
                $(target).find(tilesSelector).each(function (index, el) {
                    initMasonry(el);
                    initScrollReveal(scrollRevealTileSelector, $(el));
                });

                layoutMsnry();

                if ($('.js-grid-spinner').length) {
                    $('.js-grid-spinner').removeClass('spinner-visible');
                }
            });

            $(document).trigger('recommendation-grid-loaded'); //Trigger an event so other pages can react to this grid being loaded

            // in the end disconnect the observer
            observer.disconnect();
        });

        // configs for the observer
        const config = {
            childList: true,
            subtree: true
        };

        // set the observer on the target
        observer.observe(target, config);
    });
}

/**
* @description Initialize block
*/
function initBlock() {
    initCount = $('.js-product-tile').length;

    $(document).on('click', '.js-product-tile', function () {
        setScrollYPositionInState();
    });

    if ($(tilesSelector).length) {
        // only init for not empty grids
        $(tilesSelector).each(function (index) { /* eslint-disable-line */
            const $this = $(this);

            // if empty, do nothing
            if ($this.html().trim().length === 0) {
                return true;
            }

            if (!$this.hasClass('js-grid-slider') || !isSmallView()) {

                // Prepare defered images if present
                damHelper.updateImages($this);
                prepareDeferedImages($this);

                // Set height for elements that have class 'js-equal-height'
                equalHeight($('.js-equal-height', this));

                $this.imagesLoaded(function () {
                    $('.js-grid-initial-load-spinner').removeClass('spinner-visible');
                    $('.js-grid-product-number').removeClass('grid-number-hidden');

                    removeEmptyGWP();

                    if (!$this.hasClass('js-question-grid') || ($this.hasClass('js-question-grid') && !isSmallView())) {
                        initGridAndScroll($this);
                    }

                    layoutMsnry();
                    scrollAndResetYPositionInState();
                });
            }

            //do not tab through product name and description in product tile
            $(this).find('.js-product-name-link').attr('tabindex', '-1');
        });
    }

    outOfStockBtnAlignment();
}

function outOfStockBtnAlignment() {
    $(masonryTileSelector + ' .js-out-of-stock-wrap:not(.hide)').each(function () {
        const userActions = $(this).parents('.js-product-user-actions');
        const className = 'form-wide';
        userActions.addClass(className);
    });
}

function removeEmptyGWP() {
    const gwpWrap = $('.js-gwp-grid-item');

    if (!gwpWrap.length || $('.js-gwp-banner', gwpWrap).length) {
        return;
    }

    gwpWrap.remove();
}

function initGridAndScroll(el){
    initMasonry(el);

    // get non empty grids
    const selector = isSmallView() ? tilesSelector + ':not(.js-grid-slider)' : tilesSelector;
    const $grids = $(selector).filter(function () {
        return $.trim($(this).html()).length !== 0;
    });

    if ($grids.length === $('.grid-initialized').length) {
        $grids.each(function(){
            initScrollReveal(scrollRevealTileSelector, $(this));
        });
    }

    if ($('.js-scroll-animation-wrapper').data('animation-type') !== 'banner-video-animation'){
        scrollAnimation.init();
    }
    productGrid.pushProductsToDataLayer(tileSelectors);
}

/**
* @description Initialize event handlers for the grid
*/
function initializeEvents() {
    const recommendationBlock = $('[id^=cq_recomm]');

    // if there are einstein slots and they contain a grid
    if (recommendationBlock.length && recommendationBlock.find(tilesSelector)){
        initRecommendationGridObserver();
    }

    if ($(tilesSelector).length || recommendationBlock.length || $('.js-grid-placeholder').length || $('.js-product-list-slider-block').length) {
        $(window).off('scroll.grid').on('scroll.grid', debounce(function () {
            productGrid.pushProductsToDataLayer(tileSelectors);
        }, 300));
    }
}


const grid = {
    init: function() {
        initBlock();
        loadItemsFromState();
        initializeEvents();
        bundleVariationSwatches.init();
    },
    getContainers: function(){ return msnryContainers;},
    updateLoadMoreUrl: updateLoadMoreUrl,
    updateProductsSeenAndTotalNumbers: updateProductsSeenAndTotalNumbers,
    appendNewElements : appendNewElements,
    reinitGridLayout: reinitGridLayout
};

function loadMoreGrid(event, itemsCount, callback) {
    let $loadMore = $('.js-grid-load-more');

    if (event){
        $loadMore = $(event.target);
    }

    let url = $loadMore.data('grid-next-page-url') || Urls.productPartialGrid;
    const loadedViaUrl = $loadMore.data('grid-next-page-url');
    const ritual = $loadMore.data('ritual');
    const startIndex = $loadMore.data('start-index');
    const endIndex = $loadMore.data('end-index');
    let pageSize = $loadMore.data('page-size');
    const isSearch = $loadMore.data('is-search');

    if (itemsCount && itemsCount > initCount){
        pageSize = itemsCount - initCount;
        url = updateQueryStringParameter(url, 'sz', pageSize);
    } else if (!event){
        callback();
        return;
    }

    const requestFormat = getQueryParameter(url, 'format');
    const source = ($loadMore.parents('section').data('anchor-id') === 'collection-product-grid' && !loadedViaUrl) ? 'collection' : getQueryParameter(url, 'source');

    const requestData = {
        ritual: ritual,
        start: startIndex,
        isSearch: isSearch,
        source: source
    };

    if (!requestFormat){
        requestData.format = 'ajax';
    }

    $.ajax({
        type: 'GET',
        url: url,
        data: requestData,
        success: function (data) {
            if (data) {
                const newElements = $(data);
                newElements.addClass('js-reveal-tile-new');
                const container = $loadMore.parent().prev(':data("msnry-id")');
                container.append(newElements);
                const $container = container.find(newElements.filter('.js-reveal-tile'));
                damHelper.updateImages($container);
                prepareDeferedImages($container);

                $container.imagesLoaded(function() {
                    appendNewElements(newElements, container, event);
                    callback();
                    $('.js-grid-load-more-spinner').removeClass('spinner-visible');
                    $loadMore.removeClass('button-loading');
                    updateProductsSeenAndTotalNumbers();
                });

                if (loadedViaUrl) {
                    updateLoadMoreUrl($loadMore);
                } else {
                    if (endIndex <= startIndex + pageSize) {
                        $('.js-grid-load-more-holder').hide();
                    }

                    $loadMore.data('start-index', startIndex + pageSize);
                    $loadMore.removeAttr('disabled');
                }

                outOfStockBtnAlignment();
                setGridItemCountInState();
                
                pushDataLayerEvent({
                    event: 'interaction',
                    click_target: 'show more',
                    interaction_type: 'button',
                    content_name: 'product grid'
                });
            }
        }
    });
}

function setGridItemCountInState() {
    const currentState = window.history.state;
    if (!currentState) {
        return;
    }
    const gridPageSize = $('.js-filtered-grid-placeholder').data('page-size');
    currentState.gridItemCount = currentState.gridItemCount ? (currentState.gridItemCount + gridPageSize) : gridPageSize;
    window.history.replaceState(currentState, '', window.location.href);
}

function setScrollYPositionInState() {
    if (!window.history.state) {
        window.history.pushState({}, '', window.location.href);
    }
    const historyState = window.history.state;
    historyState.scrollYPosition = window.scrollY;
    window.history.replaceState(historyState, '', window.location.href);
}

// Update number of seen and total products on page (above Load More button)
function updateProductsSeenAndTotalNumbers() {
    const productsSeen = $('.js-products-seen-text');
    if (!productsSeen.length) {
        return;
    }
    $('.js-products-seen').text(productsSeen.val());
    productsSeen.remove();

    const totalProducts = $('.js-total-products-text');

    if (!totalProducts.length) {
        return;
    }

    $('.js-total-products').text(totalProducts.val());
    totalProducts.remove();
}

function appendNewElements(newElements, gridWrapper, event){
    const msnryId = gridWrapper.data('msnry-id');
    const msnryObj = msnryContainers.get(msnryId);

    if (!msnryObj) {
        return;
    }

    msnryObj.once('layoutComplete', function () {
        initScrollReveal($('.js-reveal-tile', gridWrapper), gridWrapper);

        if (event && event.screenX === 0) {
            newElements.find('.js-product-tile').eq(0).focus();
        }

        productGrid.pushProductsToDataLayer(tileSelectors);
    });

    msnryObj.appended(newElements);
}

function reinitGridLayout(msnryId){
    const msnryObj = msnryId ? msnryContainers.get(msnryId) : msnryContainers.values().next().value;

    if (!msnryObj) {
        return;
    }

    msnryObj.layout();
}

function updateLoadMoreUrl(loadMoreEl) {
    const $loadMore = loadMoreEl ? loadMoreEl : $('.js-grid-load-more');

    $loadMore.removeAttr('disabled');
    const newUrlField = $('.js-next-product-grid-page-url');

    if (!window.history.state) {
        window.history.pushState({}, '', window.location.href);
    }

    if (newUrlField.length > 0) {
        $loadMore.data('grid-next-page-url', newUrlField.last().val());
        $('.js-grid-load-more-holder').show();
        newUrlField.remove();
        return;
    }

    $('.js-grid-load-more-holder').hide();
}

function loadItemsFromState(){
    if (isSearchPage &&
        history.state &&
        history.state.loaded &&
        history.state.offset &&
        window.performance &&
        window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD
    ) {
        scrollHelper.disableScroll();
        loadMoreGrid(null, history.state.loaded, function() {
            scrollHelper.enableScroll();
            $('html, body').scrollTop(history.state.offset);
            $('.js-grid-load-more').data('grid-next-page-url', history.state.loadurl);

            if ($(this).data('animation-type') !== 'banner-video-animation'){
                scrollAnimation.init();
            }
            $('.js-scroll-animation-wrapper').each(function () {
                const $thisBanner = $(this);
                if ($thisBanner.data('animation-type') === 'candle-holder') {
                    $('img', $thisBanner).each((i, image) => {
                        const src = (isSmallView()) ? $(image).data('mobile-img') : $(image).data('desktop-img');
                        $(image).attr('src', src);
                    });
                }
            });
        });
    }
}

function scrollAndResetYPositionInState() {
    if (window.history.state && window.history.state.scrollYPosition) {
        window.scrollTo(window.scrollX, window.history.state.scrollYPosition);
        window.history.state.gridItemCount = null;
        window.history.state.scrollYPosition = null;
    }
}

function layoutMsnry(){
    if (typeof msnryContainers !== 'undefined') {
        for (const [key, value] of msnryContainers) { /* eslint-disable-line */
            if (value.layouted) {
                continue;
            }

            value.layout();
            value.layouted = true;
        }
    }
}

let stateAlreadySet = false; //Flag to not repeat this function multiple times

function setState(){
    if (stateAlreadySet) {
        return;
    }

    stateAlreadySet = true;
    const count = $('.js-product-tile').length;
    const offset = $(document).scrollTop();
    const loadUrl = $('.js-grid-load-more').data('grid-next-page-url');
    const state = history.state ? history.state : {};
    state.loaded = count;
    state.offset = offset;
    state.loadurl = loadUrl || '';
    history.replaceState(state, '', location.href);
}

$(document).on('click', '.js-grid-load-more', function(e) {
    e.preventDefault();
    $(this).attr('disabled', true);

    loadMoreGrid(e, 0, function(){
        if ($('.js-scroll-animation-wrapper').data('animation-type') !== 'banner-video-animation'){
            scrollAnimation.init();
        }
    });

    $('.js-grid-load-more-spinner').addClass('spinner-visible');
    $(this).addClass('button-loading');
});

function removeToggle(){
    if ($('.js-toggle-slider-promotion').length){
        for (let i = 0; i <= $('.js-toggle-slider-promotion').length; i++){
            const sliderPromoDiv = document.querySelector('.toggle-slider-promo');
            if (sliderPromoDiv){
                sliderPromoDiv.classList.remove('toggle-slider-promo');
            }
        }
    }
}
$(window).on('load', removeToggle);
$(window).on('load', layoutMsnry);

if (isSearchPage){
    $(window).on('beforeunload', setState);
    $(window).on('unload', setState);
    $(document).on('pagehide', setState);
}

module.exports = grid;
